export default __webpack_public_path__ + "static/media/img-truck.4f1a83eb.jpg";